import PropTypes from 'prop-types';

import { cn } from '#/lib/utils';

/** 詳情資訊卡欄位（版型同非庫存採購單 MainInfoCard）。 */
const FmsInfoField = ({ label, value, className }) => (
  <div className={cn('min-w-0', className)}>
    <p className="text-xs text-gray-500">{label}</p>
    <p className="mt-0.5 text-sm font-medium wrap-break-word text-gray-900">{value}</p>
  </div>
);

FmsInfoField.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default FmsInfoField;
